import { LegalLayout, type LegalSection } from '@mgp/ui';

const SECTIONS: LegalSection[] = [
  {
    id: 'platform-terms',
    number: '1',
    title: 'Platform terms',
    body: (
      <p>
        By accessing and using Adspert, you agree to be bound by these Terms of Service. The
        platform provides gaming entertainment for players and an advertising marketplace for
        advertisers. Continued use of the platform constitutes acceptance of these terms.
      </p>
    ),
  },
  {
    id: 'payments',
    number: '2',
    title: 'Payments and refunds',
    body: (
      <p>
        Advertiser payments are processed as on-chain cryptocurrency transfers. Once a payment
        has been approved by the platform and credited to your advertiser balance, it is
        non-refundable. Verify all transaction details before submitting a top-up request.
      </p>
    ),
    subsections: [
      {
        id: 'payments-minimum',
        number: '2.1',
        title: 'Minimum top-up',
        body: (
          <p>
            The minimum advertiser top-up is the equivalent of $100 USD at the time of the
            transaction. Smaller amounts will be rejected without crediting your balance.
          </p>
        ),
      },
      {
        id: 'payments-rejection',
        number: '2.2',
        title: 'Rejection',
        body: (
          <p>
            If a top-up is rejected, no funds are debited or credited inside the platform. The
            on-chain transaction itself remains as completed on the public ledger.
          </p>
        ),
      },
    ],
  },
  {
    id: 'admin-approval',
    number: '3',
    title: 'Admin approval',
    body: (
      <p>
        All advertisements and payment submissions are subject to review and approval by the
        platform administration team. The platform reserves the right to reject any ad or
        payment submission, with or without detailed justification.
      </p>
    ),
  },
  {
    id: 'content',
    number: '4',
    title: 'Content review',
    body: (
      <p>
        The platform reserves the right to review, modify, reject, or remove any ad content at
        any time, for any reason — including content that violates applicable laws, promotes
        harmful products, or is deemed inappropriate for the gaming audience.
      </p>
    ),
  },
  {
    id: 'termination',
    number: '5',
    title: 'Account termination',
    body: (
      <p>
        The platform reserves the right to suspend or terminate user accounts that violate these
        terms, engage in fraudulent activity, or abuse the platform in any way. Remaining
        advertiser balances on terminated accounts are forfeited unless local regulations
        require otherwise.
      </p>
    ),
  },
  {
    id: 'liability',
    number: '6',
    title: 'Limitation of liability',
    body: (
      <p>
        The platform is provided &ldquo;as is&rdquo; without warranties of any kind. The
        platform shall not be liable for indirect, incidental, or consequential damages arising
        from your use of the service.
      </p>
    ),
  },
  {
    id: 'contact',
    number: '7',
    title: 'Contact',
    body: (
      <p>
        For questions about these terms, contact{' '}
        <a
          href="mailto:legal@adspert.io"
          className="font-medium text-primary underline-offset-4 hover:underline"
        >
          legal@adspert.io
        </a>
        .
      </p>
    ),
  },
];

export function TermsPage() {
  return (
    <LegalLayout
      eyebrow="Terms"
      title="Terms of Service"
      lastUpdated="2026-04-19"
      intro={
        <p>
          The rules of the road for using Adspert as a player or advertiser. Plain English where
          possible — write to us if anything below needs clarifying.
        </p>
      }
      sections={SECTIONS}
    />
  );
}
